import React, { createContext, useContext } from "react";

import { MedicalPlanMapping } from "Features/MedicalPlanMappings/medicalPlanMappings.types";

interface RenewalSuitesComparisonContextType {
  selectedMapping: MedicalPlanMapping | null;
  setSelectedMapping: React.Dispatch<React.SetStateAction<MedicalPlanMapping | null>>;
}

export const RenewalSuitesComparisonContext = createContext<RenewalSuitesComparisonContextType | null>(null);

export const useRenewalSuitesComparisonContext = () => useContext(RenewalSuitesComparisonContext);

export const RenewalSuitesComparisonContextProvider = ({ children }) => {
  const [selectedMapping, setSelectedMapping] = React.useState<MedicalPlanMapping | null>(null);
  const contextValue = React.useMemo(() => ({ selectedMapping, setSelectedMapping }), [selectedMapping]);
  return <RenewalSuitesComparisonContext.Provider value={contextValue}>{children}</RenewalSuitesComparisonContext.Provider>;
};
